export default "__VITE_ASSET__Cq7nB4$8__"